var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _path, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _path2, _path3, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _symbol138, _symbol139, _symbol140, _symbol141;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpriteSystemIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    type: "system-icons",
    style: {
      display: "block"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "CIEM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5.5h-2a2 2 0 0 0-2 2v2m11-4h2a2 2 0 0 1 2 2v2m-15 7v2a2 2 0 0 0 2 2h2m7 0h2a2 2 0 0 0 2-2v-2m-4 0L13 10m-3-.003L12 8m.5 4.5L7 7",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 2,
    stroke: "#354764"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "Interface_Folder_Add"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.667 1.5c-.31 0-.607.126-.825.351-.22.226-.342.53-.342.849v9.6c0 .318.123.623.342.848.219.226.515.352.825.352h11.666c.31 0 .607-.126.825-.351.219-.225.342-.53.342-.849V4.7a1.22 1.22 0 0 0-.342-.849 1.15 1.15 0 0 0-.825-.351H7.5c-.224 0-.393-.15-.526-.34L5.453 1.5H1.667Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6v5M5 8.5h5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "XLS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 9.5 2.5 6m0-6-2.5 6m4.5-6v6H12m3.5-6h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1v0a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1m-5-15v3a2 2 0 0 0 2 2h3m-5-5 5 5m-5-5h-7a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1H4m9.5-10v2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "accessControl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.061 7.555c.321-.873 1.557-.873 1.878 0l.12.329a1 1 0 0 0 1.11.64l.345-.06c.917-.158 1.535.912.939 1.627l-.225.269a1 1 0 0 0 0 1.28l.225.27c.596.714-.022 1.784-.94 1.625l-.344-.06a1 1 0 0 0-1.11.641l-.12.329c-.321.873-1.557.873-1.878 0l-.12-.329a1 1 0 0 0-1.11-.64l-.345.06c-.917.158-1.535-.912-.939-1.627l.225-.269a1 1 0 0 0 0-1.28l-.224-.27c-.597-.714.021-1.784.938-1.625l.345.06a1 1 0 0 0 1.11-.641l.12-.329Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.96,
    cy: 10.96,
    r: 1,
    transform: "rotate(-22.5 10.96 10.96)",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5v-4m0 0C5.426 1.118 2.875.69 1.497.559.947.506.5.948.5 1.5v9c0 .552.452.995.992 1.111C3.112 11.96 4.5 13 4.5 13m3-10.5C9.574 1.118 12.125.69 13.503.559c.55-.053.997.389.997.941v4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "acknowledge"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 4.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 11 1.5 1.5 3-3m-9 2h-2a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "add-section"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5h6m-3-3v6m-12-3h7m-7-5h15m-15-5h15",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "admission-control"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.5h-3V9Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-4A1.5 1.5 0 0 1 8.5 14v-2Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.5h-3a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "archive"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 11,
    height: 15,
    rx: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.5h-11m0 5h11m-6-8h1m-1 5h1m-1 5h1",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5v-13m-5 8 5 5 5-5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "arrow-down-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 14.5-13-13m2 13h11v-11",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.5h13m-8-5-5 5 5 5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.5h-13m8 5 5-5-5-5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5v12m5-8-5-5-5 5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "arrow-up-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 14.5 13-13m0 11v-11h-11",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "assessment"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.5h3m-3 3h3",
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5 5 7l1.5-1.5m-2 4 .5.5 1.5-1.5m-2 4 .5.5 1.5-1.5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5h3",
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0.5,
    width: 4,
    height: 2,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5H3.5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1H10",
    stroke: "#354764"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "asset-crown-jewel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0 1.793 6.275a1 1 0 0 0 .961.725h6.492a1 1 0 0 0 .961-.725L14 6.5m-12 0 4 3.47L8 6.5m6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0-4 3.47L8 6.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "assets"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 .5 5.5 1M8 .5l-5.5 1M8 .5l-4 5m4-5 4 5m1.5-4 2 4m-2-4-1.5 4m3.5 0L8 15.5m7.5-10H.5m7.5 10L.5 5.5m7.5 10-4-10m4 10 4-10M.5 5.5l2-4m0 0 1.5 4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "asterisk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.5.5.003 6.994L12.45 2.55 7.506 7.497 14.5 7.5l-6.994.003 4.944 4.947-4.947-4.944L7.5 14.5l-.003-6.994L2.55 12.45l4.944-4.947L.5 7.5l6.994-.003L2.55 2.55l4.947 4.944L7.5.5Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "attachment"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.629 5.382-5.422 5.422a1.167 1.167 0 0 1-1.65 0v0a1.167 1.167 0 0 1 0-1.65L10.411 3.3a2.333 2.333 0 0 1 3.3 0v0a2.333 2.333 0 0 1 0 3.3l-6.286 6.286a3.5 3.5 0 0 1-4.95 0v0a3.5 3.5 0 0 1 0-4.95l5.854-5.854",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "bell"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.145 12.5a.506.506 0 0 1-.372-.845c1.123-1.26 2.239-2.738 2.212-4.252v-2.83a3.91 3.91 0 0 1 .732-2.117 4.333 4.333 0 0 1 1.812-1.45c.37-.16.758-.284 1.157-.37A6.338 6.338 0 0 1 9.2.616a6.29 6.29 0 0 1 1.267.393 4.19 4.19 0 0 1 1.773 1.453c.432.63.665 1.36.671 2.108v2.833c.003 1.519 1.142 2.994 2.287 4.246.297.325.072.851-.368.851H1.145Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.782 14.408a2 2 0 0 1-3.564 0",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "board"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0.5,
    width: 4,
    height: 2,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5H3.5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1H10",
    stroke: "#354764"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "book"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5v-11m0 11c-2.074-1.382-4.625-1.81-6.003-1.941C.947 12.506.5 12.052.5 11.5v-9c0-.552.447-.994.997-.941 1.378.132 3.93.559 6.003 1.941m0 11c2.074-1.382 4.625-1.81 6.003-1.941.55-.053.997-.507.997-1.059v-9c0-.552-.447-.994-.997-.941-1.378.132-3.93.559-6.003 1.941",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "business"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1h-5v-1Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 15,
    height: 9,
    rx: 2,
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 7.5h15M7 9.5h2",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5.5v4m7-4v4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 15,
    height: 13,
    rx: 2,
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 7.5h15",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5 9 3.716 4.13a1 1 0 0 0 1.521-.04L15.5 3.5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "checkCircle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.6 8 1.6 1.6 3.2-3.2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#354764"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 5 5.293 5.293a1 1 0 0 0 1.414 0L14 5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 2 5.707 7.293a1 1 0 0 0 0 1.414L11 14",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 14 5.293-5.293a1 1 0 0 0 0-1.414L5 2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "chevron-up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 11 8.707 5.707a1 1 0 0 0-1.414 0L2 11",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "clearAll"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 8.5 7 7m0-7-7 7m7-13v0a2 2 0 0 0-2-2v0m-11 0v0a2 2 0 0 0-2 2v0m0 3v1m0 3v1m0 3v0a2 2 0 0 0 2 2v0m3-15h1m3 0h1m5 5v1m-10 9h1",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3v5l2.5 2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    stroke: "#354764"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "cloud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.78 7.5a3.53 3.53 0 0 0-2.131-1.336 4.02 4.02 0 0 0-1.172-2.472A4.13 4.13 0 0 0 6.3 3.183 4.045 4.045 0 0 0 4.658 5.38a4.083 4.083 0 0 0-.426-.023 3.643 3.643 0 0 0-2.59.966 3.555 3.555 0 0 0-1.14 2.492 3.55 3.55 0 0 0 .978 2.559A3.637 3.637 0 0 0 4.003 12.5h8.336a3.119 3.119 0 0 0 1.682-.447 3.066 3.066 0 0 0 1.17-1.274A3.021 3.021 0 0 0 14.79 7.5h-.009Z",
    stroke: "#354764"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "cloudFunction"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5c-1 0-1.5 0-2.5 2.5S5 10.5 4 10.5m1-3h3m0 0 3 3m0-3-3 3",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78 7.5a3.53 3.53 0 0 0-2.131-1.336 4.02 4.02 0 0 0-1.172-2.472A4.13 4.13 0 0 0 6.3 3.183 4.045 4.045 0 0 0 4.658 5.38a4.083 4.083 0 0 0-.426-.023 3.643 3.643 0 0 0-2.59.966 3.555 3.555 0 0 0-1.14 2.492 3.55 3.55 0 0 0 .978 2.559A3.637 3.637 0 0 0 4.003 12.5h8.336a3.119 3.119 0 0 0 1.682-.447 3.066 3.066 0 0 0 1.17-1.274A3.021 3.021 0 0 0 14.79 7.5h-.009Z",
    stroke: "#354764"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "cluster"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 4,
    rx: 0.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.5,
    width: 15,
    height: 4,
    rx: 0.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 13.5,
    width: 3,
    height: 2,
    rx: 1,
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 14.5h6m3 0h6m-12-4v4m9-4v4m0-10v2m-9-2v2m-1-4h4m5 0h1m-10 6h4m5 0h1",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "columns"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.5h6m-9 0h-4m7 3h6m-9 0h-6m9 3h6m-9 0h-6m9 3h6m-9 0h-6m9 3h4m-7 0h-6",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "comments"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.701 11.841 3.5 15.5v-4h-2a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7.454a1 1 0 0 0-.753.341ZM3.5 4.5h9m-9 3h9",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "compute"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.5h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Zm3 2h-2m2 6h-2m2-3h-2m-2-7v2m-6-2v2m3-2v2m3 12v-2m-6 2v-2m3 2v-2m-7-8h2m-2 3h2m-2 3h2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "configuration"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 2.5,
    r: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 7.5,
    r: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12.5,
    r: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.5h3m4 0h8m-15 5h8m4 0h3m-15 5h3m4 0h8",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    style: {
      fill: "#2e3f58"
    },
    fill: "none",
    id: "connected-status"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 10.3 3 9c-1.4-1.4-1.6-3.6-.6-5.2L0 1.4 1.4 0l2.4 2.4c1.6-1 3.8-.8 5.2.6l1.3 1.3-6 6zm7.4-4.6L13 7c1.4 1.4 1.6 3.6.6 5.2l2.4 2.4-1.4 1.4-2.4-2.4c-1.6 1-3.8.8-5.2-.6l-1.3-1.3 6-6z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "container-image"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.02 12.74 6.927-3.464a1 1 0 0 0 .553-.894V4.535a1 1 0 0 0-.445-.832l-2.072-1.381A1 1 0 0 0 9.98 2.26L3.053 5.724a1 1 0 0 0-.553.894v3.847a1 1 0 0 0 .445.832l2.072 1.381a1 1 0 0 0 1.002.063Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13V8.118a1 1 0 0 0-.553-.894L2.5 6",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5v3m2-4v3m2-4v3",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 13.5a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1v12Z",
    stroke: "#354764"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "containers-registry"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 9 3 1.5v3L.5 12V9Zm3-4.5 3 1.5v3l-3-1.5v-3Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5 7.5 3 1.5-3 1.5L.5 9l3-1.5Zm9-1.5 3 1.5-6 3-3-1.5 6-3Zm-3-4.5 3 1.5-6 3-3-1.5 6-3Zm-6 9 3-1.5v3l-3 1.5v-3Zm6 0 6-3v3l-6 3v-3ZM6.5 6l6-3v3l-6 3V6Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 9 3 1.5v3l-3-1.5V9Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "copy"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 .5h8.5a2 2 0 0 1 2 2v11",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "cve"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.5v-4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v4s0 4 4 4 4-4 4-4Zm-2-8v.571a.429.429 0 0 1-.429.429H5.93a.429.429 0 0 1-.429-.429V2.5a2 2 0 1 1 4 0Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 4-2.5 1.5M1 4l2.5 1.5m10 9-2.46-2.094M1.5 14.5l2.5-2m10.5-3h-3m-11 0h3m4-2v7",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "cve_text"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.5h-2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h3l2.5 8 2.5-8h1m0 4v4h4m-4-4h4m-4 0v-4m4 0h-4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "data-sensitivity"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5.5v3a2 2 0 0 0 2 2h3l-5-5Zm0 0h-7a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.5h-3V9Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-3Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "database"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 3.5,
    rx: 5.5,
    ry: 2,
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2m11-3c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.5s0-2 5.5-2 5.5 2 5.5 2v9s0 2-5.5 2-5.5-2-5.5-2v-9Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5h9v11a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-11Zm2.5 0h4V2a.5.5 0 0 0-.5-.5h-3A.5.5 0 0 0 6 2v1.5Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.5h13",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5v6m3-6v6",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "disable"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#5D6B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 3-11 10",
    stroke: "#5D6B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5a1 1 0 0 1 1-1h8.586a1 1 0 0 1 .707.293l2.414 2.414a1 1 0 0 1 .293.707V14.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-13Z",
    stroke: "#354764"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "doubleCheck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5 9 3.325 3.694a1.5 1.5 0 0 0 2.28-.06L15.5 3.5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 6.5 2.6 3.033a.5.5 0 0 0 .775-.02L12 3.5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5v-9m0 9 3-3m-3 3-3-3m-4 4v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "drag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8 12a.3.3 0 1 1 0-.019M6.8 12a.3.3 0 1 1 0-.019M10.8 8a.3.3 0 1 1 0-.019M6.8 8a.3.3 0 1 1 0-.019M10.8 4a.3.3 0 1 1 0-.019M6.8 4a.3.3 0 1 1 0-.019",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "duplicate"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5v6m-3-3h6M5 .5h8.5a2 2 0 0 1 2 2v11",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 13-1.304 1.304a1 1 0 0 1-.465.263l-2.114.529a1 1 0 0 1-1.213-1.213l.529-2.114a1 1 0 0 1 .263-.465L3 10m3 3-3-3m3 3 7.5-7.5M3 10l7.5-7.5m0 0 1.293-1.293a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414L13.5 5.5m-3-3 3 3",
    stroke: "#354764"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 3 5.868 5.417a1 1 0 0 0 1.303.046L15 3M1.5 2.5h13a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "email-attachment"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5v4a1 1 0 0 1-1 1v0a1 1 0 0 1-1-1v-4a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v4a3 3 0 0 1-3 3v0a3 3 0 0 1-3-3v-4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.5v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-6",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 9.5.911.607a1 1 0 0 0 1.155-.031L15 6",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "error"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 5.5 5 5m0-5-5 5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "events"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5h5m-5 3h5m-5 3h5",
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0.5,
    width: 4,
    height: 2,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5H3.5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1H10",
    stroke: "#354764"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "exclude"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.5h-8m8 0L7 5m2.5 2.5L7 10",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 10.5,
    width: 4,
    height: 4,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 5.5,
    width: 4,
    height: 4,
    rx: 1,
    stroke: "#354764"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8a7 7 0 1 1-7-7m-.104 8.783c-.35-2.107.187-3.673 1.14-4.626.954-.954 2.42-1.39 4.131-1.048m-1.74 3.396 2.097-2.725a.483.483 0 0 0-.088-.677L10.71 2.006",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "external-link"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5.5 7 9M15.5.5h-5m5 0v5m-8-3h-6a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "external-link-inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.5 3.5-5 5m5-5h-4m4 0v4m-6-2h-4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "favorite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.175 1.704a1 1 0 0 1 1.65 0l1.795 2.62a1 1 0 0 0 .543.393l3.046.898a1 1 0 0 1 .51 1.57L12.782 9.7a1 1 0 0 0-.207.638l.087 3.175a1 1 0 0 1-1.335.97l-2.992-1.065a1 1 0 0 0-.67 0l-2.992 1.064a1 1 0 0 1-1.335-.97l.087-3.174a1 1 0 0 0-.207-.638L1.281 7.184a1 1 0 0 1 .51-1.569l3.047-.898a1 1 0 0 0 .542-.394l1.795-2.62Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5.5v4a1 1 0 0 0 1 1h4m-5-5 5 5m-5-5h-7a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.5h15m-13 3h11m-9 3h7m-5 3h3",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "find"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 13,
    rx: 3,
    ry: 2.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 13,
    rx: 3,
    ry: 2.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13V2A1.5 1.5 0 0 0 5 .5h-.314a1.5 1.5 0 0 0-1.458 1.15L.5 13m15 0L12.776 1.65A1.5 1.5 0 0 0 11.317.5H11A1.5 1.5 0 0 0 9.5 2v3.5m0 0V13m0-7.5h-3m0 3h3",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 1.5a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l1.414 1.414a1 1 0 0 0 .707.293H14.5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-12Z",
    stroke: "#354764"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "genericImage"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 1.5a1 1 0 0 1 1-1h9.586a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V14.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-13Z",
    stroke: "#354764"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "group-columns"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.5h3m3 0h9m-9 3h2m3 0h4m-9 3h2m3 0h4m-9 3h2m3 0h4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "group-exclusion"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 11.5,
    r: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5.5h-3a1 1 0 0 0-1 1v3m11-4h3a1 1 0 0 1 1 1v3m0 7v3a1 1 0 0 1-1 1h-3m-7 0h-3a1 1 0 0 1-1-1v-3m9-8.99V2.5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 4.5,
    r: 0.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.51V2.5m-4 4.01V6.5m4 .01V6.5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "help"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5v-.09A1.91 1.91 0 0 1 7.41 3.5h.207c1.418 0 2.42 1.39 1.971 2.735v0a1.187 1.187 0 0 1-.285.463L7.944 8.06A1.522 1.522 0 0 0 7.5 9.135v0m.3 2.365a.3.3 0 1 1 0-.019",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "history"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 4.5 1 3 3-1.5m4-2.5v5l2.5 2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.5a7 7 0 1 1 1.337 4.114",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "iam-impact"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5 7.914 7.914M11 11l1.5-1.5m-3-.003 2-1.997",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.315 9.665A7.43 7.43 0 0 0 15.5 8a7.555 7.555 0 0 0-.185-1.665m-.966 5.66a7.541 7.541 0 0 1-2.354 2.354m-2.33.966A7.43 7.43 0 0 1 8 15.5a7.555 7.555 0 0 1-1.665-.185m-2.33-.966a7.542 7.542 0 0 1-2.354-2.354m-.966-2.33A7.466 7.466 0 0 1 .5 8a7.556 7.556 0 0 1 .185-1.665m.966-2.33a7.513 7.513 0 0 1 2.354-2.354m2.33-.966A7.466 7.466 0 0 1 8 .5a7.556 7.556 0 0 1 1.665.185m2.33.966a7.501 7.501 0 0 1 2.073 1.94c.098.135.192.273.28.414",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "identity-card"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 6.5,
    r: 2,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.211 10.803a3.5 3.5 0 0 1 6.586.023",
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5H13m0 2h-2.5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 15,
    height: 11,
    rx: 1,
    stroke: "#354764"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "image-protection"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.5 12-1.48.74a1 1 0 0 1-1.003-.062l-2.072-1.381a1 1 0 0 1-.445-.832V6.618a1 1 0 0 1 .553-.894L9.98 2.26a1 1 0 0 1 1.002.062l2.072 1.381a1 1 0 0 1 .445.832V6",
    stroke: "#5D6B82",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13V8.118a1 1 0 0 0-.553-.894L2.5 6",
    stroke: "#5D6B82",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5v3m2-4V7m2-1.5V6",
    stroke: "#5D6B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5H1.5a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v4.75",
    stroke: "#5D6B82",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.567c1.09 0 2.182-.534 3-1.067.818.533 1.91 1.067 3 1.067v3.466c0 2.134-3 3.467-3 3.467s-3-1.333-3-3.467V8.567Z",
    stroke: "#5D6B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "import"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .5A7.5 7.5 0 1 1 .5 8",
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.608c2.107-.351 3.673.186 4.626 1.14.954.954 1.39 2.42 1.048 4.131m-3.396-1.74 2.725 2.096a.483.483 0 0 0 .677-.088l2.097-2.725",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "none",
    id: "inactive"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6 0-1.3.4-2.5 1.1-3.5l8.4 8.4c-1 .7-2.2 1.1-3.5 1.1zm4.9-2.5L4.5 3.1C5.5 2.4 6.7 2 8 2c3.3 0 6 2.7 6 6 0 1.3-.4 2.5-1.1 3.5z"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "info"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.5V6m.3-2.5a.3.3 0 1 1 0-.019",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "installation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 15 6.252-6.252",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.31 5.604a1 1 0 0 0 1.415 0l3.37-3.37A1 1 0 1 0 13.681.82l-3.37 3.37a1 1 0 0 0 0 1.414Zm0 0L8.705 7.209",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.61 7.11 7.683 7.683a1 1 0 0 0 1.414 0l.086-.086a1 1 0 0 0 0-1.414L7.109 5.609",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.358.774A3.5 3.5 0 0 0 3.12.613l1.47 1.476a1 1 0 0 1 .256.971l-.236.857a1 1 0 0 1-.702.7l-.848.23a1 1 0 0 1-.97-.258L.615 3.111A3.5 3.5 0 1 0 5.358.774Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "issue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5v6m.309 2.469a.317.317 0 0 1-.088.22.3.3 0 0 1-.427.006.317.317 0 0 1-.014-.439.301.301 0 0 1 .427-.02c.06.054.096.131.101.213M8.715.892c1.203.856 2.33 1.447 3.787 1.63.548.069.998.527.998 1.103V8.84c0 3.76-3.85 5.846-5.382 6.527a1.505 1.505 0 0 1-1.236 0C5.35 14.686 1.5 12.6 1.5 8.84V3.625c0-.576.45-1.034.998-1.103 1.458-.183 2.584-.774 3.787-1.63a2.08 2.08 0 0 1 2.43 0Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "key"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5 6.477 6.477M13.5 13.5l2-2m-4 0 3-3",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    stroke: "#354764"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "link"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.146a2.828 2.828 0 0 1-1-4.646L10 2a2.828 2.828 0 1 1 4 4l-2.5 2.5",
    stroke: "#5D6B82",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 8-2.5 2.5a2.828 2.828 0 1 0 4 4L9 11a2.828 2.828 0 0 0-1-4.646",
    stroke: "#5D6B82",
    strokeLinecap: "round"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "listCheck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 13 1.5 1.5 3-3M10 3l1.5 1.5 3-3m-13 2h6M10 8l1.5 1.5 3-3m-13 2h6m-6 5h6",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "listView"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.5h10m-10-5h10m-10-5h10",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 3.5,
    r: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 8.5,
    r: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 13.5,
    r: 1,
    stroke: "#354764"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.943C13.5 2.945 11.025.5 8 .5S2.5 2.945 2.5 5.943v.092c0 1.846 1.198 3.066 2.2 4.521 1 1.258 1.89 2.406 2.494 3.19a1.004 1.004 0 0 0 1.6-.009c.596-.797 1.462-1.958 2.368-3.18C12.397 8.891 13.5 7.88 13.5 6.034v-.092Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 2.5,
    stroke: "#354764"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "log"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5h11a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1Zm2-12h1m2 0h4m-7 6h4m-4-4h1m2 0h1m2 4h1m-1-4h1m-7 6h1m2 0h1m-4-4h7",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "magnify"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.743 10.743a6 6 0 1 0-8.485-8.486 6 6 0 0 0 8.485 8.486Zm0 0 4.727 4.718",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "malicious"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14v1.5m2-1.5v1.5m0-5v1m2 2.5v1.5m0 0h1a1 1 0 0 0 1-1v-1.866c0-.527 2-.134 2.5-1.134.35-.7-.016-1.954-.268-2.646a1.87 1.87 0 0 1-.076-1.006C14.326 4.508 13.203.5 7.5.5 1.797.5.675 4.508 1.344 7.848c.067.336.04.685-.077 1.006C1.016 9.546.65 10.801 1 11.5c.5 1 2.5.607 2.5 1.134V14.5a1 1 0 0 0 1 1h5Z",
    stroke: "#42526D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    stroke: "#42526D",
    strokeLinecap: "round"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "many-keys"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.5V6.505m0 6.995h2m-2-2h3m9-8h-9m7.5 0v-2m-2.5 2v-3m1 12L5.623 5.623m5.327 5.327L12.5 9.5m-3 0 2-2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    stroke: "#354764"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "microscope"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.478 12.5h-2.995v-3c0-2.5-1.498-4-2.996-4H7.49v-3m7.988 10s.049-2.097 0-3c0-4.5-2.995-7-5.99-7H7.49m7.988 10H2.996m12.482 0v3H.5m6.99-13H3.745a.25.25 0 0 0-.25.25V7a.5.5 0 0 0 .5.5h2.996A.5.5 0 0 0 7.49 7V2.5Zm0 10s0 3-4.494 3m1.508-13h1.977a.01.01 0 0 0 .01-.01V.51a.01.01 0 0 0-.01-.01H4.504a.01.01 0 0 0-.01.01v1.98c0 .006.005.01.01.01Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "minus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.5h13",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "monitor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dnsysa)",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 9.5H3l1-2L5.5 11 9 3l3 8 1-1.5h2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 14.5v-13a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dnsysa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "more"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 3,
    r: 0.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 0.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13,
    r: 0.5,
    stroke: "#354764"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "network"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2.5,
    width: 4,
    height: 4,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5v-1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.5,
    width: 3,
    height: 3,
    rx: 1,
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 10.5,
    width: 4,
    height: 3,
    rx: 1,
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5v4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.5,
    width: 3,
    height: 3,
    rx: 1,
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "none",
    id: "not-connected-status"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#2e3f58"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78 9 2.64 7.86a3.69 3.69 0 0 1-.52-4.54L.03 1.23 1.25 0l2.1 2.1c1.45-.89 3.33-.67 4.54.52l1.14 1.14L3.79 9Zm8.41-2.08 1.14 1.14a3.69 3.69 0 0 1 .52 4.54l2.1 2.1-1.22 1.22-2.1-2.1c-1.45.89-3.33.67-4.54-.52l-1.14-1.14 5.24-5.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.95 5.813 1.167-1.167 1.181 1.18a.817.817 0 0 1 0 1.16.817.817 0 0 1-1.16 0l-1.18-1.18ZM4.685 8.097 5.85 6.93l1.181 1.181a.817.817 0 0 1 0 1.16.817.817 0 0 1-1.16 0L4.693 8.09Z"
  })))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "objectExplorer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.5V5.682a1 1 0 0 0-.521-.878l-4-2.182a1 1 0 0 0-.958 0l-4 2.182a1 1 0 0 0-.521.878v5.176a1 1 0 0 0 .521.878l4.032 2.2a1 1 0 0 0 .907.025l1.021-.484",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.504 5.094 6.5 8.5m0 0v5.649m0-5.649 4.992-3.414",
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 13 2 2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 2,
    stroke: "#354764"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "overview"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 8,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 7.5,
    width: 6,
    height: 8,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 0.5,
    width: 6,
    height: 4,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 11.5,
    width: 6,
    height: 4,
    rx: 1,
    stroke: "#354764"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "none",
    id: "partially-connected-status"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.98 9.21-.65-.73c-.73-.73-.81-1.86-.32-2.75L3.8 4.52l.73-.73 1.29 1.29c.81-.57 2.02-.4 2.75.32l.65.65L5.99 9.2Zm3.96-2.42.65.65c.73.73.81 1.86.32 2.75l1.29 1.29-.73.73-1.29-1.29c-.81.57-2.02.4-2.75-.32l-.65-.65L9.93 6.8Z",
    style: {
      fill: "#2e3f58"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    style: {
      fill: "none",
      stroke: "#2e3f58",
      strokeDasharray: "0 0 1.94 1.94",
      strokeMiterlimit: 10,
      strokeWidth: ".93px"
    }
  })), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.833.5H4.167a.667.667 0 0 0-.4 1.2l1.333 1a1 1 0 0 1 .4.8V6a1 1 0 0 1-.4.8l-1.2.9a1 1 0 0 0 .6 1.8h6a1 1 0 0 0 .6-1.8l-1.2-.9a1 1 0 0 1-.4-.8V3.5a1 1 0 0 1 .4-.8l1.333-1a.667.667 0 0 0-.4-1.2ZM7.5 15.5v-6",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "play"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.548 7.14 4.01.895a1 1 0 0 0-1.51.86v12.49a1 1 0 0 0 1.51.86L14.548 8.86a1 1 0 0 0 0-1.72Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5V.5m-7 7h14",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "posture-management"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.106 1.169 1.048 3.765A.904.904 0 0 0 1.404 5.5h12.192a.904.904 0 0 0 .356-1.735L7.894 1.17a1 1 0 0 0-.788 0Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 15.5h14m-12-8v6m10-6v6m-5-6v6",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "private"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#5D6B82"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 1.5,
    stroke: "#5D6B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5v3",
    stroke: "#5D6B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 2.5.336 3.423L5 4.5m6.5 6.5 2.656-.93.344 3.43m-.337-3.435A6.5 6.5 0 0 1 1.515 8.469m.322-2.534a6.5 6.5 0 0 1 12.648 1.601",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "remedy"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 14,
    height: 10,
    rx: 1,
    stroke: "#354764",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h-6v-1Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.5h6m-3-3v6",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "remove"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5 3 10 10m0-10-10 10",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "report"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.5h1m0 0h5m-5 0V11m2-2v3.5m2-2.5v2.5m-5-6h6m-6-2h6",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5a1 1 0 0 1 1-1h8.586a1 1 0 0 1 .707.293l2.414 2.414a1 1 0 0 1 .293.707V14.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-13Z",
    stroke: "#354764"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 14 16",
    id: "reports"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V3.914a.5.5 0 0 0-.146-.353l-2.415-2.415A.5.5 0 0 0 10.086 1H1.5ZM0 1.5A1.5 1.5 0 0 1 1.5 0h8.586a1.5 1.5 0 0 1 1.06.44l2.415 2.414A1.5 1.5 0 0 1 14 3.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 14.5v-13Zm3 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm3.5 2A.5.5 0 0 1 7 9v3h1v-2a.5.5 0 0 1 1 0v2h.5a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1H4v-1a.5.5 0 0 1 1 0v1h1V9a.5.5 0 0 1 .5-.5Z"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "risk-management_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.661 13.49c.848-.001 1.629-.534 1.755-1.373A7.501 7.501 0 0 0 1.874 6.673a7.5 7.5 0 0 0-1.288 5.458c.128.838.91 1.37 1.757 1.37L7.5 13.5l6.161-.01Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 13.5 3.5-6",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "robot"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.5h-7a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.5,
    r: 1,
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 7.5,
    r: 1,
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5v-2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 1.5,
    r: 1,
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.5H2A1.5 1.5 0 0 0 .5 8v1A1.5 1.5 0 0 0 2 10.5h.5m11-4h.5A1.5 1.5 0 0 1 15.5 8v1a1.5 1.5 0 0 1-1.5 1.5h-.5m-8 0v0c.306.613.933 1 1.618 1h1.764c.685 0 1.312-.387 1.618-1v0",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "rocket"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#egsysa)",
    stroke: "#354764"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2C11.458.548 13.216.44 14.287.547a1.29 1.29 0 0 1 1.168 1.166C15.566 2.782 15.458 4.537 14 6l-5.293 5.293a1 1 0 0 1-1.414 0L4.707 8.707a1 1 0 0 1 0-1.414L10 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 11.5-4 4M3 10l-1.5 1.5M6 13l-1.5 1.5m-3-7 1.414-1.414A2 2 0 0 1 4.328 5.5H6.5m4 4v2.172a2 2 0 0 1-.586 1.414L8.5 14.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 0.5
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "egsysa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "row-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.5h3m3 0h9m-9 3h2m3 0h4m-9 3h2m3 0h4m-9 3h2m3 0h4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "rule"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5H2.5a2 2 0 0 1-2-2h10v.5a1.5 1.5 0 0 0 1.5 1.5Zm0 0a1.5 1.5 0 0 0 1.5-1.5V1.5a1 1 0 0 1 1-1m0 0a1 1 0 0 1 1 1v1h-2m1-2h-10a2 2 0 0 0-2 2v11m3-10h5m-5 3h5m-5 3h5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "ruleset"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 12.5v-10a2 2 0 0 1 2-2h10m1 4h-1m0 0H7A1.5 1.5 0 0 0 5.5 6v7.5m7-9V12a1.5 1.5 0 0 1-1.5 1.5H5.5m-1 0h1m-2 2h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "runtime-protection"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.104 8.056-2.5-.534a.5.5 0 0 0-.208 0l-2.5.534a.5.5 0 0 0-.396.488v3.436c0 1.223 1.217 2.316 2.101 2.949a1.534 1.534 0 0 0 1.798 0c.884-.633 2.101-1.726 2.101-2.949V8.544a.5.5 0 0 0-.396-.488Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.045 5.96-1.89-.158a.5.5 0 0 1-.457-.456l-.077-.924a.5.5 0 0 0-.822-.34l-.707.598a.5.5 0 0 1-.646 0l-.707-.598a.5.5 0 0 0-.822.34l-.077.924a.5.5 0 0 1-.456.456l-.924.077a.5.5 0 0 0-.34.822l.598.707a.5.5 0 0 1 0 .646l-.598.707a.5.5 0 0 0 .34.822l.924.077a.5.5 0 0 1 .456.456l.082.983a.5.5 0 0 0 .801.356l.442-.336",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5a1.5 1.5 0 1 1 .559-2.892",
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 12.5,
    r: 1.5,
    transform: "rotate(-90 2.5 12.5)",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 2.5,
    r: 1.5,
    transform: "rotate(-90 12.5 2.5)",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.613 11.288A7 7 0 0 1 9.198.709m4.189 3.003A7 7 0 0 1 14.337 6m-8.535 8.29c.881.22 1.793.266 2.683.14",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "save"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#elsysa)",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.5v-13a1 1 0 0 0-1-1H3.914a1 1 0 0 0-.707.293L.793 3.207a1 1 0 0 0-.293.707V14.5a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5.5v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3m0 15v-3a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v3"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "elsysa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "security-event"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.5V5m1.753 5c-.914 2.73-4.118 4.513-5.551 5.192a1.628 1.628 0 0 1-1.403 0C4.619 14.397.5 12.082.5 8.5V3.998c0-.552.45-.989.998-1.06 2.115-.271 3.16-1.396 5.084-2.26.266-.12.57-.12.836 0M11.5 6.51V6.5m4-2a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "select-all"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 .5h8.5a2 2 0 0 1 2 2v11m-11.4-4 1.6 1.6 3.2-3.2",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "semiPublic"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.59 4.41a10.415 10.415 0 0 0-.662-1.925C10.276 1.09 9.276 0 8 0S5.724 1.089 5.072 2.485C4.508 3.694 4.134 5.265 4.03 7H1a.5.5 0 0 0 0 1h3c0 1.286.147 2.507.41 3.59l.841-.841A14.71 14.71 0 0 1 5 8h3l1-1H5.032c.103-1.607.45-3.03.946-4.092C6.593 1.59 7.343 1 8 1c.657 0 1.407.59 2.022 1.908.306.657.556 1.452.727 2.343l.84-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.305 2.695-10.61 10.61",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 9.5,
    r: 1,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5V12",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "settings"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.586 2.081a1 1 0 0 1 1.643-.68l1.125.952a1 1 0 0 0 1.292 0l1.125-.952a1 1 0 0 1 1.643.68l.122 1.47a1 1 0 0 0 .914.913l1.469.122a1 1 0 0 1 .68 1.643l-.952 1.125a1 1 0 0 0 0 1.292l.952 1.125a1 1 0 0 1-.68 1.643l-1.47.122a1 1 0 0 0-.913.914l-.122 1.469a1 1 0 0 1-1.643.68l-1.125-.952a1 1 0 0 0-1.292 0l-1.125.952a1 1 0 0 1-1.643-.68l-.122-1.47a1 1 0 0 0-.914-.913l-1.469-.122a1 1 0 0 1-.68-1.643l.952-1.125a1 1 0 0 0 0-1.292l-.952-1.125a1 1 0 0 1 .68-1.643l1.47-.122a1 1 0 0 0 .913-.914l.122-1.469Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    stroke: "#354764"
  }))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "sheet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5H2.5a2 2 0 0 1-2-2h10v.5a1.5 1.5 0 0 0 1.5 1.5Zm0 0a1.5 1.5 0 0 0 1.5-1.5V1.5a1 1 0 0 1 1-1m0 0a1 1 0 0 1 1 1v1h-2m1-2h-10a2 2 0 0 0-2 2v11",
    stroke: "#5D6B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "shiftleft"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.712 1.613a7 7 0 0 1 10.579 7.585m-3.003 4.189A7 7 0 0 1 .709 5.802M4.5 7.5h6m-6 0 2-2m-2 2 2 2M4 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm10 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "shine"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 4 .365.866a8 8 0 0 0 4.269 4.27l.866.364-.866.365a8 8 0 0 0-4.27 4.269L6 15l-.365-.866a8 8 0 0 0-4.269-4.27L.5 9.5l.866-.365a8 8 0 0 0 4.27-4.269L6 4Z",
    stroke: "#CF0FEE",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5.5.415.985a3 3 0 0 0 1.6 1.6l.985.415-.985.415a3 3 0 0 0-1.6 1.6L12.5 6.5l-.415-.985a3 3 0 0 0-1.6-1.6L9.5 3.5l.985-.415a3 3 0 0 0 1.6-1.6L12.5.5Z",
    stroke: "#7371E8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 11.5.276.656a2 2 0 0 0 1.068 1.068l.656.276-.656.276a2 2 0 0 0-1.068 1.068l-.276.656-.276-.656a2 2 0 0 0-1.068-1.068L11.5 13.5l.656-.276a2 2 0 0 0 1.068-1.068l.276-.656Z",
    stroke: "#E954DA",
    strokeLinejoin: "round"
  }))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 32 32",
    id: "shine-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 8 .73 1.733a16 16 0 0 0 8.537 8.537L23 19l-1.733.73a16 16 0 0 0-8.537 8.537L12 30l-.73-1.733a16 16 0 0 0-8.537-8.537L1 19l1.733-.73a16 16 0 0 0 8.538-8.537L12 8Z",
    stroke: "#CF0FEE",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 1 .83 1.97a6 6 0 0 0 3.2 3.2L31 7l-1.97.83a6 6 0 0 0-3.2 3.2L25 13l-.83-1.97a6 6 0 0 0-3.2-3.2L19 7l1.97-.83a6 6 0 0 0 3.2-3.2L25 1Z",
    stroke: "#7371E8",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 23 .553 1.313a4 4 0 0 0 2.134 2.134L31 27l-1.313.553a4 4 0 0 0-2.134 2.134L27 31l-.553-1.313a4 4 0 0 0-2.134-2.134L23 27l1.313-.553a4 4 0 0 0 2.134-2.134L27 23Z",
    stroke: "#E954DA",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 48 48",
    id: "shine-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 12 1.094 2.599a24 24 0 0 0 12.807 12.807L34.5 28.5l-2.599 1.094a24 24 0 0 0-12.807 12.807L18 45l-1.094-2.599A24 24 0 0 0 4.099 29.594L1.5 28.5l2.599-1.094a24 24 0 0 0 12.807-12.807L18 12Z",
    stroke: "#CF0FEE",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.5 1.5 1.244 2.954a9 9 0 0 0 4.802 4.802L46.5 10.5l-2.954 1.244a9 9 0 0 0-4.802 4.802L37.5 19.5l-1.244-2.954a9 9 0 0 0-4.802-4.802L28.5 10.5l2.954-1.244a9 9 0 0 0 4.802-4.802L37.5 1.5Z",
    stroke: "#7371E8",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.5 34.5.83 1.97a6 6 0 0 0 3.2 3.2l1.97.83-1.97.83a6 6 0 0 0-3.2 3.2l-.83 1.97-.83-1.97a6 6 0 0 0-3.2-3.2l-1.97-.83 1.97-.83a6 6 0 0 0 3.2-3.2l.83-1.97Z",
    stroke: "#E954DA",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "sidebar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-9Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.5v11m2-9h3m-3 2h3m-3 2h3m-3 2h3",
    stroke: "#354764",
    strokeLinecap: "round"
  }))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "status_error"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8Zm2.828 9.886a.667.667 0 0 1 0 .943.684.684 0 0 1-.943 0L8 8.943l-1.885 1.886a.674.674 0 0 1-.943 0 .667.667 0 0 1 0-.943L7.057 8 5.172 6.114a.667.667 0 1 1 .943-.943L8 7.057l1.885-1.886a.667.667 0 1 1 .943.943L8.943 8l1.885 1.886Z"
  }))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "status_info"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm.8 11.2a.8.8 0 1 1-1.6 0v-4a.8.8 0 0 1 1.6 0v4ZM8 5.6A.8.8 0 1 1 8 4a.8.8 0 0 1 0 1.6Z"
  }))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "status_success"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm2.829-10.829a.8.8 0 0 1 1.131 1.133l-4.522 4.522-.004.004a.799.799 0 0 1-1.13 0l-.004-.004-2.26-2.26a.8.8 0 1 1 1.131-1.13L6.87 9.131l3.96-3.96Z"
  }))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "status_warning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.283 15.097c.351.562.96.903 1.626.903h12.182a1.91 1.91 0 0 0 1.626-.903 1.92 1.92 0 0 0 .082-1.858L9.703 1.053A1.9 1.9 0 0 0 8 0a1.9 1.9 0 0 0-1.703 1.053L.2 13.239a1.92 1.92 0 0 0 .082 1.858ZM8.774 5.14v4.918a.773.773 0 1 1-1.548 0V5.141a.773.773 0 1 1 1.548 0Zm-1.548 7.742v-.563a.773.773 0 1 1 1.548 0v.563a.777.777 0 0 1-.774.774.777.777 0 0 1-.774-.774Z"
  }))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "third-party"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 10.5,
    r: 1.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 10.5,
    r: 1.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.5v2m-2 0h4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 2 2 1v2.5l-2 1-2-1V3l2-1Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "timelineChart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5v14a1 1 0 0 0 1 1h14",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 11 2.293-2.293a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 0 1.414 0L15 5",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "tips"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.437 7.5a2 2 0 0 1-3.874 0",
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5V9",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12c0-.556.34-1.046.801-1.358a5 5 0 1 0-5.602 0c.46.312.801.802.801 1.358",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12v2A1.5 1.5 0 0 0 7 15.5h1A1.5 1.5 0 0 0 9.5 14v-2m-4 .5h4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "traffic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5 9.5 4 5v-13m7 5-4-5v13",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "unarchive"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.59 15.16c.641-2.1.417-3.265-.427-4.365-.844-1.102-2.734-1.107-4.524-.988m0 0 1.771 3.06m-1.77-3.06a.497.497 0 0 1 .18-.679l3.06-1.772",
    stroke: "#354764",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.5h-11m0 5H8m-.5-8h1m-1 5h1m-1 5h1m5-7v-3a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h7",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "unlink"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 5 3-3a2.828 2.828 0 1 1 4 4l-3 3",
    stroke: "#5D6B82",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 12.5 2 2m-4-1.5v2.5m2-5h3m-14-9 2 2m2-2.5v2.5m-5 2h3",
    stroke: "#5D6B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 11-3.5 3.5a2.828 2.828 0 1 1-4-4L5 7",
    stroke: "#5D6B82",
    strokeLinecap: "round"
  }))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "unpin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.833V4.167a.667.667 0 0 0-1.2-.4l-1 1.333a1 1 0 0 1-.8.4H10a1 1 0 0 1-.8-.4l-.9-1.2a1 1 0 0 0-1.8.6v6a1 1 0 0 0 1.8.6l.9-1.2a1 1 0 0 1 .8-.4h2.5a1 1 0 0 1 .8.4l1 1.333a.667.667 0 0 0 1.2-.4ZM.5 7.5h6",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5v9m0-9-3 3m3-3 3 3m-10 7v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "user"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 3.5,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.357 15.5h11.286a.857.857 0 0 0 .857-.857A5.143 5.143 0 0 0 9.357 9.5H6.643A5.143 5.143 0 0 0 1.5 14.643c0 .473.384.857.857.857Z",
    stroke: "#354764",
    strokeLinejoin: "round"
  }))), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "users"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.049 1.17a2.537 2.537 0 1 0 0 5.074 2.537 2.537 0 0 0 0-5.073ZM2.34 3.708a3.707 3.707 0 1 1 7.415 0 3.707 3.707 0 0 1-7.415 0Zm7.805-2.341c0-.323.262-.586.586-.586a2.927 2.927 0 1 1 0 5.854.585.585 0 1 1 0-1.17 1.756 1.756 0 1 0 0-3.513.585.585 0 0 1-.586-.585Zm-8.25 8.21c1.091-.623 2.561-.99 4.153-.99 1.591 0 3.061.367 4.153.99 1.076.615 1.896 1.554 1.896 2.717s-.82 2.1-1.896 2.716C9.11 15.633 7.64 16 6.05 16a9.526 9.526 0 0 1-2.588-.347.585.585 0 1 1 .32-1.126 8.36 8.36 0 0 0 2.268.302c1.425 0 2.687-.331 3.573-.837.901-.515 1.305-1.138 1.305-1.7 0-.56-.404-1.183-1.305-1.699-.886-.505-2.148-.837-3.573-.837-1.426 0-2.688.332-3.573.837-.902.516-1.305 1.138-1.305 1.7 0 .18.04.36.12.54a.585.585 0 0 1-1.067.48A2.474 2.474 0 0 1 0 12.294c0-1.163.82-2.101 1.895-2.716Zm10.605.25a.585.585 0 0 1 .698-.447c.75.165 1.427.462 1.929.873s.872.975.872 1.65c0 .608-.302 1.129-.728 1.525-.424.394-.998.693-1.64.886a.585.585 0 1 1-.337-1.121c.518-.156.92-.38 1.18-.623.26-.241.354-.47.354-.667 0-.215-.116-.476-.442-.743-.327-.267-.82-.5-1.44-.636a.585.585 0 0 1-.446-.697Z"
  }))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "warning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.612 1.717.755 13.041a1 1 0 0 0 .888 1.459h11.714a1 1 0 0 0 .888-1.46L8.388 1.718a1 1 0 0 0-1.776 0ZM7.5 5.5v4",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8 12a.3.3 0 1 1 0-.019",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "web"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5c0 2.015-.382 3.815-.978 5.092C8.907 13.91 8.157 14.5 7.5 14.5c-.657 0-1.407-.59-2.022-1.908C4.882 11.315 4.5 9.515 4.5 7.5c0-2.015.382-3.815.978-5.092C6.093 1.09 6.843.5 7.5.5c.657 0 1.407.59 2.022 1.908.596 1.277.978 3.077.978 5.092Z",
    stroke: "#354764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 7.5h14",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 16 16",
    id: "workload-protection"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 8 1.5 1.5 3-3M8.732.824c1.73.84 2.773 1.858 4.77 2.115.548.07.998.507.998 1.06V8.5c0 3.582-4.118 5.897-5.799 6.692a1.627 1.627 0 0 1-1.402 0C5.619 14.397 1.5 12.082 1.5 8.5V3.998c0-.552.45-.989.998-1.06 1.997-.256 3.04-1.273 4.77-2.114a1.675 1.675 0 0 1 1.464 0Z",
    stroke: "#354764",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpriteSystemIcons);
export default __webpack_public_path__ + "static/media/sprite_system-icons.fa3c2a9aae79bc466c048e2b33b70343.svg";
export { ForwardRef as ReactComponent };